module.exports = __webpack_public_path__ + "assets/img/87.14536cdb.png";